import React, { useMemo, useState, FC, useEffect } from 'react'
import { Chip } from '@components/std-components/Chip'
import { ListItemElement } from '@components/std-components/SelectComponent'
import { SelectPopup, SelectPopupProps } from '@components/std-components/SelectPopup'
import ColorCircle from '@components/UI-Components/ChipList/ColorCircle'
import { AddIcon, CrossIcon, NewAddIcon } from '@components/UI-Components/svg'
import difference from 'lodash/difference'
import ChipList from '@components/UI-Components/ChipSelect/components/ChipList/ChipList'
import { SelectListItemColumn } from '@components/UI-Components/ChipSelect/components/SelectListItem'
import classNames from 'classnames'
import { CentricTypography as Typography } from '@core/component/CentricTypography'

export interface ChipListProps extends Omit<SelectPopupProps, 'trigger'> {}

export const EnhancedRMClusterChip: ({ colorMap, classes }) => FC<ListItemElement> = ({
  colorMap,
  classes
}) => {
  return ({ isSelected, onDeselect, onSelect, option, disabled, index }) => {
    return (
      <Chip
        tooltip={option}
        key={option}
        offset={{ bottom: 12 }}
        className={classNames(classes.chip, { disabled: disabled })}
      >
        <div className={classes.colorItem}>
          <ColorCircle color={colorMap[option]} />
        </div>
        <Typography
          variant='captionDarkGrey'
          className={classNames(classes.content, 'text-ellipsis')}
        >
          {option}
        </Typography>
        {!disabled && (
          <span className={classNames('flex', classes.chipAction)}>
            {isSelected ? (
              <img
                src={CrossIcon}
                className='icon-16'
                alt={'Remove'}
                onClick={() => onDeselect()}
              />
            ) : (
              <img
                src={AddIcon}
                className='icon-16'
                alt={'Add'}
                onClick={() => onSelect()}
              />
            )}
          </span>
        )}
      </Chip>
    )
  }
}
export const EnhancedChipSelect: FC<ChipListProps> = ({ ...props }) => {
  const [selected, setSelected] = useState(props.selected)

  useEffect(() => {
    setSelected(props.selected)
  }, [props.selected])
  const options = useMemo(
    () => difference(props.options, selected),
    [props.options, selected]
  )

  return (
    <SelectPopup
      trigger={
        <>
          <div
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
            }}
          >
            <ChipList
              itemTemplate={props.itemTemplate}
              onDeselect={option => {
                const newSelection = difference(selected, [option])
                setSelected(newSelection)
                props.onSelect({ selected: newSelection })
              }}
              values={selected}
              disabled={props.disabled}
            />
          </div>
          {!props.disabled && options?.length > 0 && (
            <div>
              <img src={NewAddIcon} alt='Add' />
            </div>
          )}
        </>
      }
      {...props}
      closeOnSelect={true}
      onSelect={({ selected: currSelected }) => {
        setSelected(currSelected)
        props.onSelect({ selected: currSelected })
      }}
      contentStyle={{ width: 'fit-content', padding: 10 }}
      selected={selected}
      options={options}
      listElementTemplate={SelectListItemColumn}
      itemTemplate={props.itemTemplate}
    />
  )
}
